import { render, staticRenderFns } from "./AccountCertificateFormMVR.vue?vue&type=template&id=18aa1e9a&scoped=true&"
import script from "./AccountCertificateFormMVR.vue?vue&type=script&lang=ts&"
export * from "./AccountCertificateFormMVR.vue?vue&type=script&lang=ts&"
import style0 from "./AccountCertificateFormMVR.vue?vue&type=style&index=0&id=18aa1e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aa1e9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
